var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.97 22C17.4928 22 21.97 17.5228 21.97 12C21.97 6.47715 17.4928 2 11.97 2C6.44712 2 1.96997 6.47715 1.96997 12C1.96997 17.5228 6.44712 22 11.97 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9701 10.2301L12.0701 8.56012C11.3501 8.14012 10.4801 8.14012 9.76011 8.56012C9.04011 8.98012 8.61011 9.72012 8.61011 10.5601V13.9101C8.61011 14.7401 9.04011 15.4901 9.76011 15.9101C10.1201 16.1201 10.5201 16.2201 10.9101 16.2201C11.3101 16.2201 11.7001 16.1201 12.0601 15.9101L14.9601 14.2401C15.6801 13.8201 16.1101 13.0801 16.1101 12.2401C16.1301 11.4001 15.7001 10.6501 14.9701 10.2301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.c1b68931eec20f491d40eb3c04b3a254.svg";
export { ForwardRef as ReactComponent };